
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/victory",
      function () {
        return require("private-next-pages/victory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/victory"])
      });
    }
  